import React, { useState } from "react";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import api from "../../../../src/services/auth/api";

// const baseURL = "http://127.0.0.1:8000/storage/";


const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const handleChangePassword = async (e) => {
    e.preventDefault();

    // Validation
    if (newPassword.length < 6) {
      Swal.fire({
        icon: "error",
        title: "Invalid Password!",
        text: "New password must be at least 6 characters long.",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Passwords do not match!",
        text: "Please make sure both passwords are the same.",
      });
      return;
    }

    try {
      const authToken = localStorage.getItem("authToken");
      const response = await api.put(
        `${process.env.REACT_APP_HOST}api/users/change-password`,
        {
          old_password: oldPassword,
          password: newPassword,
          c_password: confirmPassword,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Password Changed Successfully!",
          text: "You will be redirected to the login page.",
        }).then(() => {
          navigate("/shop/auths/login");
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.message || "Something went wrong.",
      });
    }
  };

  return (
    <Layout title="Change-Password">
      <Block>
        <Card>
          <Card.Body>
            <h4 className="mb-3">Change Password</h4>
            <Form onSubmit={handleChangePassword}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Old Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter old password"
                      value={oldPassword}
                      onChange={(e) => setOldPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter new password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Confirm New Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Confirm new password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Button variant="primary" type="submit">
                Change Password
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Block>
    </Layout>
  );
};

export default ChangePassword;
